"use client";
import Script from "next/script";
import { initializeLogger } from ".";

export const FeLoggerClient = ({
  homepagePaths,
  src,
}: {
  homepagePaths: Set<string>;
  src: string;
}) => (
  <Script
    onReady={() => {
      initializeLogger({
        // The controlled logger route enriches this header at the edge.
        subscriptionKey: "",
        ...(homepagePaths.has(document.location.pathname) && {
          additionalData: {
            homepage: "DotNext",
          },
        }),
      })();
    }}
    src={src}
  />
);
